module.exports = __webpack_public_path__ + "static/GorditaLight-Italic-43b5ea0cd42b5ecda5161d85b281a142.woff";